<modal-container #modal [headerTitle]="title" [headerIconClass]="'fa-info-circle'">
  <ng-container class="modal-body-content">
    <p [ngClass]="{ 'text-center': bodyCentered }">
      {{ body }}
    </p>
  </ng-container>
</modal-container>
